import { getLocale } from "../runtime";

const sv_grcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Grekland`
};

const grcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_grcountry(inputs)
	return "grCountry";
};

export { grcountry as "grCountry" };